import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout'

const routes = [
  {
    path: '/',
    redirect: "/home",
  },
  {
    path: "/home",
    component: Layout,
    redirect: "/home/index",
    children: [
      {
        path: "index",
        name: "index",
        component: () => import("@/views/home/index.vue"),
      },
      {
        path: "report/:target",
        name: "report",
        component: () => import("@/views/report/index.vue"),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  const title = "百川盈孚2022年年报"
  if (to.name === "report") {
    document.title = title + "-" +  to.params.target
  } else {
    document.title = title
  }
  next()
})

export default router
